<template>
    <v-container fluid style="padding:0px">   
      <LeftMenu/> 
        <div width="100%" height="100%">
            <img src="https://www.inovenso.com/wp-content/uploads/2018/09/inovenso-boston-2.png"
             width="100%" height="100%">
        </div>

    </v-container>
</template>


<script>
import LeftMenu from '../components/LeftMenu';
export default {
    components:{
      LeftMenu
    }
}
</script>
